export type TTabs = 'Esta semana' | 'Este mes' | 'Este año';
export const TABS: { [key: string]: TTabs } = {
	WEEKLY: "Esta semana",
	MONTHLY: 'Este mes',
	YEARLY: 'Este año',
};
